import { AutoComplete, Input } from "antd"; // Assuming Ant Design is used
import { CloseSquareFilled } from "@ant-design/icons";
import SearchIcon from "../../assets/images/searchIcon.svg"; // Adjust the path to your SearchIcon

const RenderInput = ({
  posConfig,
  options,
  productMap,
  pickProduct,
  productSearchInput,
  setProductSearchInput,
  setOptions,
  keyboard,
  filterDrawer,
  searchInputRef,
  clearProductSearchResults,
  onChangeInput,
  setOpen,
  setInputName,
  setIsInputFocused,
  onBarcodeInput,
  productSearchInputRef,
}) => {
  if (posConfig?.product_search_display_mode === "dropdown") {
    return (
      <AutoComplete
        id="autocomplete-sm-product"
        options={options}
        style={{ width: "100%", border: "none" }}
        onSelect={(value) => {
          const selectedProduct = productMap[value];
          pickProduct(selectedProduct);
          setProductSearchInput("");
          setOptions([]);
          if (keyboard.current) {
            keyboard.current.setInput("");
          }
        }}
        value={productSearchInput}
        onChange={setProductSearchInput}
        open={options.length > 0 && !filterDrawer}
        defaultActiveFirstOption={true}
        onBlur={() => {
          setOptions([]);
        }}
      >
        <Input
          placeholder="Search for products by code/name"
          id="sm-product-search"
          ref={searchInputRef}
          onChange={(e) => {
            e.target.value === "" ? clearProductSearchResults() : onChangeInput(e);
          }}
          onKeyDown={(e) => {
            if (e.key === "Enter" && options.length === 1) {
              e.preventDefault();
              const selectedProduct = productMap[options[0].value];
              if (selectedProduct) {
                pickProduct(selectedProduct);
                setProductSearchInput("");
                setOptions([]);
                if (keyboard.current) {
                  keyboard.current.setInput("");
                }
              }
            }
          }}
          className="productSearch-sm"
          style={{
            borderRadius: "7px",
            padding: "0.8vh 0.8vw",
            borderColor: "#fff",
          }}
          value={productSearchInput}
          onFocus={(e) => {
            setTimeout(() => {
              setOpen(true);
              setInputName("productSearch");
              keyboard?.current?.setInput(productSearchInput);
            }, 150);
          }}
          onBlur={() => {
            setIsInputFocused(false);
          }}
          suffix={
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {productSearchInput.length > 0 ? (
                <CloseSquareFilled
                  style={{ fontSize: "20px", color: "#2F3856" }}
                  onClick={(e) => {
                    e.stopPropagation();
                    if (productSearchInputRef?.current) {
                      productSearchInputRef?.current?.clearInput();
                    }
                    setTimeout(() => {
                      setOpen(false);
                      setProductSearchInput("");
                      setOptions([]);
                      const productSearchInput = document.getElementById("sm-product-search");
                      if (productSearchInput) {
                        productSearchInput.blur();
                      }
                      keyboard?.current?.setInput("");
                    }, 200);
                    localStorage.removeItem("productName");
                  }}
                />
              ) : null}
            </div>
          }
          prefix={
            <img
              src={SearchIcon}
              alt=""
              onClick={() => {
                onBarcodeInput(productSearchInput, false);
              }}
            />
          }
        />
      </AutoComplete>
    );
  } else {
    return (
      <Input
        placeholder="Search for products by code/name"
        id="sm-product-search"
        onChange={(e) => {
          e.target.value === "" ? clearProductSearchResults() : onChangeInput(e);
        }}
        className="productSearch-sm"
        style={{
          borderRadius: "7px",
          padding: "0.8vh 0.8vw",
          borderColor: "#fff",
        }}
        value={productSearchInput}
        onFocus={(e) => {
          setTimeout(() => {
            setOpen(true);
            setInputName("productSearch");
            keyboard?.current?.setInput(productSearchInput);
          }, 150);
        }}
        onBlur={() => {
          setIsInputFocused(false);
        }}
        suffix={
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {productSearchInput.length > 0 ? (
              <CloseSquareFilled
                style={{ fontSize: "20px", color: "#2F3856" }}
                onClick={(e) => {
                  e.stopPropagation();
                  if (productSearchInputRef?.current) {
                    productSearchInputRef?.current?.clearInput();
                  }
                  setTimeout(() => {
                    setOpen(false);
                    setProductSearchInput("");
                    const productSearchInput = document.getElementById("sm-product-search");
                    if (productSearchInput) {
                      productSearchInput.blur();
                    }
                    keyboard?.current?.setInput("");
                  }, 200);
                }}
              />
            ) : null}
          </div>
        }
        prefix={
          <img
            src={SearchIcon}
            alt=""
            onClick={() => {
              onBarcodeInput(productSearchInput, false);
            }}
          />
        }
      />
    );
  }
};

export default RenderInput;
